import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
//@ts-ignore 
import { PannellumVideo } from 'pannellum-react'
//@ts-ignore
import VideoTour from '../../../assets/tour_360.mp4'
//@ts-ignore
import MobileVideoTour from '../../../assets/tour.mp4'
import Theme from '../../../Theme'
import TimeStamp from './TimeStamp'
import Unmute from './../icons/Unmute'
import Mute from './../icons/Mute'
import Play from './../icons/Play'
import Pause from './../icons/Pause'
import { chapters } from '../../../other/constants'
import { ClickAndDrag } from '../../Map/components/View3D'
import MapImg from '../../../assets/map.svg'
import ReplayImg from '../../../assets/replay.svg'
import useMobile from '../../../other/Hooks/useMobile'
import useOrientation from '../../../other/Hooks/useOrientation'

const Container = styled.div`
    position:relative;
    width:100%;
    height:${({ isLandscape }: { isLandscape: boolean }) => isLandscape ? window.innerHeight : window.innerHeight}px;
    background-color:grey;
`
const ControlsContainer = styled.div`
    z-index: 5;
    position:absolute;
    bottom:50px;
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;

    @media screen  and (max-width:${Theme.devices.tablet}),(max-height:${Theme.devices.tablet}){
        right: 60px;
        bottom: 0px;
    }
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
        bottom: 50px;
        right: 5px;
        left: 5px;
        justify-content: space-between;
    }
    left:0;
    right:0;
    cursor:pointer;
`
const Navigation = styled.span<{ visible: boolean, position: 'left' | 'right' }>`
    visibility:${({ visible }) => visible ? 'visible' : 'hidden'};
    margin-left:${({ position }) => position === "left" ? "20px" : ""};
    margin-right:${({ position }) => position === "right" ? "20px" : ""};
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
        margin-left: 10px;
        margin-right: 10px;
    }
`

const Time = styled.div`
    color:white;
    display: flex;
    justify-content: center;
    align-items: center;

     > time {
         min-width: 47.5px;
         display: inline-flex;
         text-align: center;
         @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
            min-width: 38px;
        }
    }
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
       font-size: 14px;
       font-weight: 600;
       position: absolute;
       opacity: 0;
       pointer-events: none;
   }
`
const ProgressBarContainer = styled.div`
    height:5px;
    background-color: white;
    max-width:700px;
    width:40%;
    position:relative;
    margin-right:30px;
    margin-left:30px;
    flex-grow: 1;
    @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
        margin-left: 10px;
        margin-right: 10px;
    }
`
const ProgressBar = styled.div`
    height:100%;
    width:0%;
    background-color:${Theme.colors.BrandOrange};
    pointer-events: none;
`

const Volume = styled.div<{ mute: boolean }>`
display:flex;
flex-direction:column;
width:18px;
transform:translateY(-25px);
margin-left:20px;
@media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
    margin-left: 10px; 
}
:hover {
    input[type=range] {
        visibility:${({ mute }) => mute ? 'hidden' : 'visible'};  
    }
}

input[type=range] {
    height: 2px;
    -webkit-appearance: none;
    width: 49px;
    visibility:hidden;
    transform:rotate(-90deg) translate(-37px,10px);
    transform-origin:left bottom;
  }
  input[type=range]:focus {
    outline: none;
  }
  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    background: white;
  }
  input[type=range]::-webkit-slider-thumb {
    height: 10px;
    width: 5px;
    background: #ED8B00;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -4px;
  }
  input[type=range]:focus::-webkit-slider-runnable-track {
    background: white;
  }
  input[type=range]::-moz-range-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    background: white;
  }
  input[type=range]::-moz-range-thumb {
    height: 10px;
    width: 5px;
    background: #ED8B00;
    cursor: pointer;
  }
  input[type=range]::-ms-track {
    width: 100%;
    height: 2px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  input[type=range]::-ms-fill-lower {
    background: white;
  }
  input[type=range]::-ms-fill-upper {
    background: white;
  }
  input[type=range]::-ms-thumb {
    margin-top: 1px;
    height: 10px;
    width: 5px;
    background: #ED8B00;
    cursor: pointer;
  }
  input[type=range]:focus::-ms-fill-lower {
    background:white;
  }
  input[type=range]:focus::-ms-fill-upper {
    background: white;
  }
`

const EndWrap = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 11;
  background-color: rgb(50 56 64 / 80%);
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
      padding: 40px;
      cursor: pointer;
  }
`

const End = ({ replay, toMap }: { replay: () => void, toMap: () => void }) => (
    <EndWrap>
        <div onClick={replay}>
            <img src={ReplayImg} />
        </div>
        <div onClick={toMap}>
            <img src={MapImg} />
        </div>
    </EndWrap>
)

const timestamps = chapters.map(chapter => chapter.timestamp)
function formatTime(totalSeconds: number) {
    const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0')
    const seconds = Math.floor(totalSeconds % 60).toString().padStart(2, '0')
    return { minutes, seconds }
}

const VideoPlayer = React.memo(PannellumVideo)

export default function Video({ timestamp, toMap, menuOpen, ...props }: { timestamp: number, toMap: () => void, menuOpen: boolean, setPlaying: (v: boolean) => void }) {

    const [currentChapter, setCurrentChapter] = useState(0)
    const isMobile = useMobile()
    const isLandscape = useOrientation()
    const [metaloaded, setMetaLoaded] = useState(false)
    const [playing, setPlaying] = useState(true)
    const [mute, setMute] = useState(false)
    const videoPlayer = useRef<HTMLVideoElement>(null)
    const duration = useRef<HTMLTimeElement>(null)
    const timeElapsed = useRef<HTMLTimeElement>(null)
    const progressBar = useRef<HTMLDivElement>(null)
    const volume = useRef<HTMLInputElement>(null)


    //@ts-ignore
    const getVideo = () => ((isMobile ? videoPlayer.current : (videoPlayer.current && videoPlayer.current.videoNode)) || {}) as HTMLVideoElement

    useEffect(() => {
        const video = getVideo()
        if (menuOpen && !video.paused) {
            video.pause()
            setPlaying(false)
            props.setPlaying(false)
        }
    }, [menuOpen])

    const togglePlay = () => {
        const video = getVideo()
        if (video.paused) {
            video.play()
            setPlaying(true)
            props.setPlaying(true)
        } else {
            video.pause()
            setPlaying(false)
            props.setPlaying(false)
        }
    }
    const toggleAudio = () => {
        const video = getVideo()
        if (video.muted) {
            video.muted = false
            setMute(false)
        } else {
            video.muted = true
            setMute(true)
        }
    }
    const changeVolume = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseFloat(e.target.value)
        const video = getVideo()
        video.volume = value
        if (value === 0) setMute(true)
    }

    useEffect(() => {

        if (!videoPlayer.current) return

        //@ts-ignore
        const video = getVideo()

        video.currentTime = timestamp
        const getVideoDuration = () => {
            if (!video || !video.duration) return
            const time = formatTime(video.duration)
            if (duration && duration.current) {
                duration.current.innerText = `${time.minutes}:${time.seconds}`
                setMetaLoaded(true)
            }
        }
        const updateTimeElapsed = () => {
            const time = formatTime(video.currentTime)
            if (timeElapsed && timeElapsed.current) timeElapsed.current.innerText = `${time.minutes}:${time.seconds}`
            const progress = (video.currentTime) / (video.duration) * 100 + '%'
            if (progressBar && progressBar.current) progressBar.current.style.width = progress
        }
        const updateCurrentChapter = () => {
            const passedChapters = timestamps.filter((timestamp) => video.currentTime >= timestamp)
            setCurrentChapter(passedChapters.length - 1)
        }

        video.addEventListener('loadedmetadata', getVideoDuration)
        video.addEventListener('timeupdate', updateTimeElapsed)
        video.addEventListener('timeupdate', updateCurrentChapter)
        return function cleanup() {
            video.removeEventListener('loadedmetadata', getVideoDuration)
            video.removeEventListener('timeupdate', updateTimeElapsed)
            video.removeEventListener('timeupdate', updateCurrentChapter)
        }


    }, [videoPlayer])



    useEffect(() => {
        const video = getVideo()
        //@ts-ignore
        video.currentTime = timestamp
    }, [timestamp])


    const video = getVideo()
    //@ts-ignore
    let didEnd = videoPlayer.current && (video.duration - video.currentTime) < 3

    console.log({ isLandscape })
    return (
        <Container isLandscape={isLandscape}>
            {
                didEnd && <End
                    toMap={toMap}
                    replay={() => {
                        //@ts-ignore
                        const video = videoPlayer.current?.videoNode
                        video.currentTime = 0
                        video.play()
                        setPlaying(true)
                    }}
                />
            }
            {
                isMobile && <video width="100%" height="100%" autoPlay={true} loop={true} muted ref={videoPlayer} style={{ objectFit: 'cover' }}>
                    <source src={MobileVideoTour} type="video/mp4" />
                    Your browser does not support the video tag.
              </video>
            }

            {
                !isMobile && <VideoPlayer
                    hfov={500}
                    video={VideoTour}
                    width="100%"
                    height="100%"
                    ref={videoPlayer}
                    autoplay={false}
                    muted={false}
                />
            }

            <ClickAndDrag LS_NAME='liuana_video' />
            {
                !didEnd &&
                <ControlsContainer>
                    <span onClick={togglePlay}>
                        {playing ?
                            <Pause isMobile={isMobile} />
                            :
                            <Play isMobile={isMobile} />
                        }
                    </span>
                    <ProgressBarContainer
                        onClick={e => {
                            const { pageX, target } = e
                            // @ts-ignore  
                            const { x, width } = target?.getBoundingClientRect()
                            const percentage = (pageX - x) / width
                            const video = getVideo()
                            // @ts-ignore  
                            const newTime = video.duration * percentage
                            // @ts-ignore  
                            video.currentTime = newTime
                        }}
                    >
                        <ProgressBar ref={progressBar} />
                        {metaloaded &&
                            chapters.map((chapter, index) => <TimeStamp
                                key={index}
                                chapter={chapter.name}
                                skipToTimeStamp={(e) => {
                                    e.stopPropagation()
                                    const video = getVideo()
                                    //@ts-ignore
                                    video.currentTime = chapter.timestamp
                                }}
                                watched={index <= currentChapter}
                                position={//@ts-ignore
                                    (chapter.timestamp) / (getVideo().duration) * 100 + "%"}
                            />
                            )
                        }
                    </ProgressBarContainer>
                    <Time>
                        <time ref={timeElapsed}>00:00</time>
                        <span >&nbsp;|&nbsp;</span>
                        <time ref={duration}>00:00</time>
                    </Time>
                    <Volume mute={mute}>
                        <div style={{ height: 54 }} >
                            <input type="range" min={0} max={1} defaultValue={0.5} step={0.1} onChange={changeVolume} />
                        </div>
                        <span onClick={toggleAudio}>
                            {
                                mute ?
                                    <Mute />
                                    :
                                    <Unmute />
                            }
                        </span>

                    </Volume>
                </ControlsContainer>

            }
        </Container>
    )
}